export default __webpack_public_path__ + "static/Image_2-1d83b7abbe026503b5f17c515ec34a12.jpg";